const tabs = {
  roulette: [],
  nuevo: [],
  popular: [],
  xMas: [],
};

function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    // TODO судя по таску все игры будут в 'crash' категории когда пойдет в прод
    ['slotMachines', 'crash'],
  );
  return trueTab;
}

export { getTab };
